import { render, staticRenderFns } from "./template.html?vue&type=template&id=446c9e3c&scoped=true&external"
import script from "./activate-mfa.vue?vue&type=script&lang=js"
export * from "./activate-mfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c9e3c",
  null
  
)

export default component.exports